import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { CheckinSendPage } from './checkin-send';

import { CheckinAnswersModule } from '../../pages/checkin-answers/checkin-answers.module';
import { CheckinChannelsModule } from '../../pages/checkin-channels/checkin-channels.module';
import { PersonSelectModule } from '../../pages/person-select/person-select.module';

import { PersonAvatarModule } from '../../components/person-avatar/person-avatar.module';
import { SendViaModule } from '../../components/send-via/send-via.module';
import { HumanizeModule } from '../../pipes/humanize/humanize.module';
import { DateTimeModule } from '../../pipes/date-time/date-time.module';

@NgModule({
  declarations: [
    CheckinSendPage
  ],
  imports: [
    SendViaModule,
    HumanizeModule,
    DateTimeModule,
    PersonAvatarModule,
    PersonSelectModule,
    CheckinAnswersModule,
    IonicPageModule.forChild(CheckinSendPage)
  ],
  exports: [
    CheckinSendPage
  ],
  entryComponents: [
    CheckinSendPage
  ]
})
export class CheckinSendModule {}



// WEBPACK FOOTER //
// ./src/pages/checkin-send/checkin-send.module.ts